import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { DateDICT } from 'utils/enum'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const TOP_UP_AUTO_RECHARGE_RESULT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'TOP_UP_AUTO_RECHARGE_RESULT')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/lifecenter/autoRecharge/queryConfigDetail',
        method: 'POST',
        body: data,
        requestAction: TOP_UP_AUTO_RECHARGE_RESULT.INIT_REQUEST,
        successAction: TOP_UP_AUTO_RECHARGE_RESULT.INIT_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TOP_UP_AUTO_RECHARGE_RESULT.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [TOP_UP_AUTO_RECHARGE_RESULT.INIT_SUCCESS]: (state, action) => {
    const { config = {} } = action.payload
    console.log(config)
    config.date = _.chain(DateDICT)
      .filter((item) => item.replace(/[a-z]+/, '') === config.autoPaymentDay)
      .head()
      .value()
    return Object.assign({}, state, action.payload)
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'topUpAutoRechargeResult',
    reducerMap: {
      topUpAutoRechargeResultState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
